/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import {
	SuccessCheckModal,
	PlainSelect,
	SelectDropDown,
} from "../../../layout/CustomComponents";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineClose } from "react-icons/md";
import PhoneInput from "react-phone-input-2";
import { CustomGreenBtn, CustomWhiteBtn } from "../../../layout/CustomButtons";
import { IsValidIcon } from "../../../layout/assets";
import Container from "../../../layout/Container";
import { useDispatch, useSelector } from "react-redux";
import ModalContainer from "../../../components/ModalContainer";
import {
	addBankAccToPage,
	closeAddBankAccountModal,
	closeAddBvnModal,
	openAddBankAccountModal,
	openAddBvnModal,
} from "../../../redux/authRedux/authActions";
import AddBankAccountModal from "../../../components/AddBankAccountModal";
import AddBvnModal from "../../../components/AddBvnModal";
import {
	addBankAccount,
	disableEmailButton,
	disablePhoneButton,
	getPhoneOTP,
	getWorkEmailOtp,
	updateUserAndPersonalData,
	verifyEmailOtp,
	verifyPhoneOTP,
} from "../../../redux/authRedux/authServices";
import { toast } from "react-toastify";
import {
	deepEqual,
	formatPhoneNumber,
	futureDate,
	validateEmail,
} from "../../../common/utils";
import { Preloader } from "../../../components/globalStyled";
import CountDown from "../../../components/Countdown";
import { closePersonalForm } from "../../../redux/lease/leaseActions";
import PropTypes from "prop-types";
import Parse from "../../../api/ApiConfig";
import moment from "moment";

const PersonalForm = ({ onCloseForm }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	const currentSessionToken = Parse.User.current()?.getSessionToken();

	const { savingPersonalFormSuccess } = useSelector((state) => state.lease);
	const {
		currentUser,
		updatingUserAccountLoading,
		bankToPage,
		toggleAddBankAccountModal,
		toggleAddBvnModal,
		phoneOtpMessageLoading,
		phoneOtpMessageSuccess,
		isShowPhoneTimer,
		verifyPhoneOtpLoading,
		verifyPhoneOtpSuccess,
		currentPhone,
		emailOtpMessageLoading,
		emailOtpMessageSuccess,
		isShowEmailTimer,
		verifyEmailOtpLoading,
		verifyEmailOtpSuccess,
		currentEmail,
		verifyBvnSuccess,
		bankAccountSuccess,
		bvnSuccessMsg,
	} = useSelector((state) => state.auth);

	const [toggleWorkStatus, setToggleWorkStatus] = useState(false);
	const [toggleSalaryRange, setToggleSalaryRange] = useState(false);
	const [toggleNumberOfDependent, setToggleNumberOfDependent] = useState(false);
	const [toggleIdType, setToggleIdType] = useState(false);

	const bank_info =
		savingPersonalFormSuccess && savingPersonalFormSuccess?.get("bankAccounts")
			? savingPersonalFormSuccess?.get("bankAccounts")
			: [];

	const generalAccount = currentUser?.accountNumber
		? {
				bankName: currentUser?.bankName,
				accountNo: currentUser?.accountNumber,
				accountName: currentUser?.accountName,
		  }
		: null;

	const [personalForm, setPersonalForm] = useState({
		phone_number: currentUser?.phone || "",
		phone_code: "",
		work_email: currentUser?.workEmail || "",
		email_code: "",
		employer_name: currentUser?.employerName || "",
		home_address: currentUser?.homeAddress || "",
		work_status: currentUser?.workStatus || "",
		salary_range: currentUser?.salaryRange || "",
		id_number: currentUser?.idNo || "",
		expiry_date: currentUser?.idExpiryDate
			? moment(currentUser?.idExpiryDate?.iso).format("YYYY-MM-DD")
			: "",
		number_of_dependent: currentUser?.numberOfDependants || "",
		id_type: currentUser?.idType || "",
		bvn: currentUser?.bvn || verifyBvnSuccess?.bvn || "",
		bank_account: bankToPage || generalAccount || null,
	});

	const dirtyField = {
		phone_number: currentUser?.phone,
		phone_code: "",
		work_email: currentUser?.workEmail,
		email_code: "",
		employer_name: currentUser?.employerName,
		home_address: currentUser?.homeAddress,
		work_status: currentUser?.workStatus,
		salary_range: currentUser?.salaryRange,
		id_number: currentUser?.idNo,
		expiry_date: currentUser?.idExpiryDate
			? moment(currentUser?.idExpiryDate?.iso).format("YYYY-MM-DD")
			: "",
		number_of_dependent: currentUser?.numberOfDependants,
		id_type: currentUser?.idType,
		bvn: currentUser?.bvn,
		bank_account: generalAccount || null,
	};

	const {
		phone_number,
		phone_code,
		work_email,
		email_code,
		employer_name,
		home_address,
		id_type,
		id_number,
		expiry_date,
		work_status,
		salary_range,
		number_of_dependent,
		bvn,
		bank_account,
	} = personalForm;

	const handleChange = (e) =>
		setPersonalForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

	// get phoneOTP
	const onGetPhoneOtp = () => {
		if (!phone_number.startsWith("234")) {
			toast.error("Please include country code");
		} else if (phone_number.length < 12) {
			toast.error("Please include country code");
		} else {
			const phone = formatPhoneNumber(phone_number);
			dispatch(getPhoneOTP(phone));
		}
	};

	// disable resend phone otp while counter
	useEffect(() => {
		if (isShowPhoneTimer) {
			dispatch(disablePhoneButton(1000 * 115));
		}
	}, [isShowPhoneTimer]);

	//verify phoneotp code
	useEffect(() => {
		if (verifyPhoneOtpSuccess) {
			setPersonalForm((prev) => ({ ...prev, phone_code: "" }));
			return;
		}
		if (phone_code.length < 6) {
			return;
		} else if (isNaN(phone_code)) {
			return;
		} else {
			dispatch(verifyPhoneOTP(phone_number, phone_code));
		}
	}, [phone_code]);

	// check if phone is still valid
	const checkPhone = () => {
		if (
			formatPhoneNumber(currentUser?.phone) ===
				formatPhoneNumber(phone_number) &&
			currentUser?.phoneVerified
		) {
			return true;
		}
		if (
			verifyPhoneOtpSuccess &&
			currentPhone === formatPhoneNumber(phone_number)
		) {
			return true;
		} else {
			return false;
		}
	};

	// check email validity
	const isEmailValid = validateEmail(work_email);

	// get email otp
	const onGetEmailOtp = () => {
		if (isEmailValid) {
			dispatch(getWorkEmailOtp({ workEmail: work_email }, currentSessionToken));
		} else {
			toast.error("WorkEmail is not valid");
		}
	};

	//verify email otp
	useEffect(() => {
		if (verifyEmailOtpSuccess) {
			setPersonalForm((prev) => ({ ...prev, email_code: "" }));
			return;
		}
		if (email_code.length < 6) {
			return;
		} else if (isNaN(email_code)) {
			return;
		} else {
			dispatch(verifyEmailOtp({ workEmail: work_email, otp: email_code }));
		}
	}, [email_code]);

	// check if phone is still valid
	const checkEmail = () => {
		if (
			currentUser?.workEmail === work_email
			// &&currentUser?.workEmailVerified
		) {
			return true;
		}
		if (verifyEmailOtpSuccess && currentEmail === work_email) {
			return true;
		} else {
			return false;
		}
	};
	// console.log(checkEmail());

	// disable resend email otp while counter
	useEffect(() => {
		if (isShowEmailTimer) {
			dispatch(disableEmailButton(1000 * 115));
		}
	}, [isShowEmailTimer]);

	const isBvnAddSuccess = () => {
		dispatch(closeAddBvnModal());
		setPersonalForm((prev) => ({ ...prev, bvn: verifyBvnSuccess?.bvn }));
	};

	const isBankAccountAddSuccess = () => {
		dispatch(closeAddBankAccountModal());
		dispatch(addBankAccToPage(bankAccountSuccess));
		setPersonalForm((prev) => ({ ...prev, bank_account: bankAccountSuccess }));
	};

	const isProceedBtnValid = () => {
		if (
			!checkPhone() ||
			!checkEmail() ||
			employer_name === "" ||
			home_address === "" ||
			id_type === "" ||
			id_number === "" ||
			work_status === "" ||
			number_of_dependent === "" ||
			bvn === "" ||
			bank_account === null
		) {
			return true;
		}
		if (id_type === "International Passport" && expiry_date === "") {
			return true;
		}
		if (id_type === "Driver's Licence" && expiry_date === "") {
			return true;
		} else {
			return false;
		}
	};

	const handleToggleWorkStatus = () => {
		setToggleWorkStatus((prev) => !prev);
		setToggleSalaryRange(false);
	};
	const handleToggleSalaryRange = () => {
		setToggleSalaryRange((prev) => !prev);
		setToggleNumberOfDependent(false);
		setToggleIdType(false);
	};

	// validate if form values has chnaged from previous
	const isFormsDeepEqual = deepEqual(dirtyField, personalForm);

	const User = Parse.Object.extend("_User");
	const user = new User();
	user.id = Parse.User.current()?.id;

	const a = bank_info?.find((b) => b?.accountNo === bank_account?.accountNo);
	const date = expiry_date || futureDate;
	const dateObj = new Date(date);

	const data = {
		gender:
			verifyBvnSuccess?.gender || savingPersonalFormSuccess?.get("gender"),
		bankAccounts: a ? bank_info : [...bank_info, bank_account],
		workStatus: work_status,
		userId: user,
		user: user,
		workEmail: work_email,
		phone: phone_number,
		salaryRange: salary_range,
		homeAddress: home_address,
		DOB:
			moment(verifyBvnSuccess?.dob).format("DD-MM-YYYY") ||
			moment(currentUser?.dateOfBirth).format("DD-MM-YYYY") ||
			moment(currentUser?.DOB).format("DD-MM-YYYY"),
		employers: employer_name,
		numberOfDependants: number_of_dependent,
		fullName: `${currentUser?.firstName} ${currentUser?.lastName}`,
		BVN: bvn,
		email: currentUser?.email || work_email,
		idType: id_type,
		idNumber: id_number,
		idExpiryDate: moment(dateObj).format("YYYY-MM-DD"),
	};

	const dataForUserProfile = {
		gender:
			verifyBvnSuccess?.gender ||
			currentUser?.gender ||
			savingPersonalFormSuccess?.get("gender"),
		workStatus: work_status,
		workEmail: work_email,
		phone: phone_number,
		salaryRange: salary_range,
		homeAddress: home_address,
		DOB:
			moment(verifyBvnSuccess?.dob).format("DD-MM-YYYY") ||
			moment(currentUser?.dateOfBirth).format("DD-MM-YYYY") ||
			moment(currentUser?.DOB).format("DD-MM-YYYY"),
		dateOfBirth:
			moment(verifyBvnSuccess?.dob).format("DD-MM-YYYY") ||
			moment(currentUser?.dateOfBirth).format("DD-MM-YYYY") ||
			moment(currentUser?.DOB).format("DD-MM-YYYY"),
		employerName: employer_name,
		numberOfDependants: number_of_dependent,
		bvn,
		idType: id_type,
		idNo: id_number,
		bankName: bank_account?.bankName,
		accountName: bank_account?.accountName,
		accountNumber: bank_account?.accountNo,
		idExpiryDate: {
			__type: "Date",
			iso: dateObj?.toISOString(),
		},
	};

	const onProceedToMarketPlace = () => {
		navigate("/leasing/new-transaction/market-place");
		setTimeout(() => {
			dispatch(closePersonalForm());
		}, 200);
	};
	console.log(isFormsDeepEqual);

	const onProceedBtnClick = () => {
		if (isFormsDeepEqual) {
			onProceedToMarketPlace();
		} else {
			dispatch(
				updateUserAndPersonalData(
					data,
					dataForUserProfile,
					"form saved successfully"
				)
			);
		}
	};

	const addBankAccountDetails = (data) => {
		dispatch(addBankAccount(data));
	};

	// console.log(phoneOtpMessageLoading);

	return (
		<>
			{toggleAddBankAccountModal && (
				<ModalContainer modal={toggleAddBankAccountModal}>
					{bankAccountSuccess ? (
						<SuccessCheckModal
							text="Account added successfully"
							onRequestClick={isBankAccountAddSuccess}
							isShowBtn={true}
						/>
					) : (
						<AddBankAccountModal onRequestClick={addBankAccountDetails} />
					)}
				</ModalContainer>
			)}
			{toggleAddBvnModal && (
				<ModalContainer modal={toggleAddBvnModal}>
					{bvnSuccessMsg ? (
						<SuccessCheckModal
							text="BVN Verified successfully"
							onRequestClick={isBvnAddSuccess}
							isShowBtn={true}
						/>
					) : (
						<AddBvnModal />
					)}
				</ModalContainer>
			)}

			<Container>
				<div className="-mt-1 mb-5 sm:my-5 md:my-6 py-4 sm:py-5 lg:py-6 bg-[#F6F7F8] rounded-md space-y-4 sm:space-y-5 lg:space-y-6 w-full h-[82vh] sm:h-[84vh] md:h-[87vh] lg:h-[88vh]">
					<div className="flex items-center justify-between px-4 sm:px-5 lg:px-6">
						<p className="text-[15px] font-medium chillaxFont">Personal</p>
						<button className="font-semibold" onClick={onCloseForm}>
							<MdOutlineClose color="#00525D" size={20} />
						</button>
					</div>
					<div className="space-y-5 h-[89%] overflow-y-auto scroll-wrapper px-4 sm:px-5 lg:px-6">
						<div className="border border-[#D4DEE2] rounded flex p-3 items-center justify-between bg-[#EEF2F3]">
							<div className="text-[#393F42]">
								<p className="text-[13px] font-semibold zabalMedFont">
									One Final Step!
								</p>
								<small className="zabalMedFont opacity-75 text-xs leading-[5px">
									Complete your profile to access lease services.
								</small>
							</div>
						</div>
						<div className="space-y-5 md:space-y-6">
							<div className="grid gap-4 md:gap-5 lg:gap-6">
								{/* handle BVN Verification */}
								<div className="mt-2 sm:mt-0 flex items-center justify-between sm:justify-normal gap-2 sm:gap-5">
									<p className="text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
										Bank Verification Number (BVN) :
									</p>
									<div className="sm:w-[65%] md:w-3/5 xl:w-4/6 text-fortcore-green font-semibold zabalMedFont text-[13px] lg:text-sm">
										{bvn ? (
											<p>{bvn}</p>
										) : (
											<button onClick={() => dispatch(openAddBvnModal())}>
												Add BVN
											</button>
										)}
									</div>
								</div>

								{/* handle phone number input */}
								<div className="flex flex-col items-center sm:flex-row gap-2 sm:gap-5">
									<p className="w-full text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
										Verification Phone Number :
									</p>
									<div
										className={`relative w-full sm:w-[65%] md:w-3/5 xl:w-4/6 ${
											checkPhone() ? "mb-0" : "mb-2"
										}`}
									>
										<PhoneInput
											country={"ng"}
											inputClass="!text-[12.5px] lg:!text-[13px] !w-full !h-full rounded border !border-[#B8B8B8] text-[#393F42] !bg-transparent outline-none focus:!border-2 focus:!border-fortcore-green zabalRegFont"
											containerClass="!text-[12.5px] lg:!text-[13px] !w-full !border-[#B8B8B8] !h-[45px] zabalRegFont focus:!border-2 focus:!border-fortcore-green"
											value={phone_number}
											onChange={(phone_number) =>
												setPersonalForm({
													...personalForm,
													phone_number: phone_number,
												})
											}
											inputProps={{ maxLength: 19 }}
										/>
										{!checkPhone() && (
											<p className="absolute pt-0.5 text-xs zabalMedFont text-red-500">
												Phone number must be verified
											</p>
										)}
										<div className="absolute flex gap-2 items-center right-3 h-[45px] top-0">
											{checkPhone() && (
												<span>
													<IsValidIcon width="15px" height="15px" />
												</span>
											)}
											{!phoneOtpMessageSuccess && !checkPhone() && (
												<button
													className={`h-full flex items-center justify-center md:w-[60px] text-xs md:text-[12.5px] font-semibold zabalMedFont ${
														phoneOtpMessageLoading || phone_number.length < 12
															? "text-[#717E83]"
															: "text-fortcore-green"
													} ${
														phoneOtpMessageLoading ? "w-[42px]" : "w-[56px]"
													}`}
													onClick={onGetPhoneOtp}
													disabled={
														phoneOtpMessageLoading || phone_number.length < 12
													}
												>
													{phoneOtpMessageLoading ? <Preloader /> : "Get Code"}
												</button>
											)}
										</div>
									</div>
								</div>

								{/* handle phone number otp Verification */}
								{phoneOtpMessageSuccess && (
									<div className="flex flex-col items-center sm:flex-row gap-2 sm:gap-4 md:gap-5 text-xs md:text-[13px]">
										<p className="w-full text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
											Enter Code :
										</p>
										<div className="space-y-1.5 w-full sm:w-[65%] md:w-3/5 xl:w-4/6">
											<div className="relative h-[45px] w-full zabalMedFont">
												<input
													type="tel"
													className="text-sm h-full w-full px-2.5 rounded border border-[#B8B8B8] text-[#393F42] bg-transparent outline-none placeholder:text-[#B8B8B8] zabalRegFont focus:border-2 focus:border-fortcore-green"
													placeholder="phone number otp"
													maxLength={6}
													name="phone_code"
													value={phone_code}
													onChange={handleChange}
												/>
												{verifyPhoneOtpLoading && (
													<div className="absolute right-2.5 top-0 h-full w-[55px] grid place-items-center">
														<Preloader />
													</div>
												)}
											</div>
											<div className="pl-4 pr-2 text-[11px] flex justify-between text-fortcore-green zabalMedFont">
												{isShowPhoneTimer && <CountDown timer={115} />}
												<div className="space-x-1.5 justify-self-end ">
													<span className="text-[#393F42]">
														Didn&apos;t get code?
													</span>
													<button
														className={`font-semibold ${
															isShowPhoneTimer ||
															phoneOtpMessageLoading ||
															phone_number.length < 12
																? "text-[#717E83]"
																: "text-fortcore-green"
														}`}
														onClick={onGetPhoneOtp}
														disabled={
															isShowPhoneTimer ||
															phoneOtpMessageLoading ||
															phone_number.length < 12
														}
													>
														{phoneOtpMessageLoading
															? "Sending..."
															: "Resend Code"}
													</button>
												</div>
											</div>
										</div>
									</div>
								)}

								{/* handle email input */}
								<div className="flex flex-col items-center sm:flex-row gap-2 sm:gap-4 md:gap-5">
									<p className="w-full text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
										Work Email / Scheme Code:
									</p>
									<div
										className={`h-[45px] relative w-full sm:w-[65%] md:w-3/5 xl:w-4/6 ${
											checkEmail() ? "mb-0" : "mb-2"
										}`}
									>
										<input
											type="email"
											className="zabalRegFont h-full tracking-wide w-full px-2.5 rounded border border-[#B8B8B8] text-[#393F42] bg-transparent outline-none text-[13px] lg:text-sm placeholder:text-[#B8B8B8] focus:border-2 focus:border-fortcore-green"
											placeholder="work email"
											name="work_email"
											value={work_email}
											onChange={handleChange}
										/>
										{!checkEmail() && (
											<p className="absolute pt-0.5 text-xs zabalMedFont text-red-500">
												Work Email must be verified
											</p>
										)}
										<div className="absolute flex gap-2 items-center right-3 h-full top-0">
											{checkEmail() && (
												<span>
													<IsValidIcon width="15px" height="15px" />
												</span>
											)}
											{!emailOtpMessageSuccess && !checkEmail() && (
												<button
													className={`h-full flex items-center justify-center md:w-[60px] text-xs md:text-[12.5px] font-semibold zabalMedFont ${
														emailOtpMessageLoading || !isEmailValid
															? "text-[#717E83]"
															: "text-fortcore-green"
													} ${
														emailOtpMessageLoading ? "w-[42px]" : "w-[56px]"
													}`}
													onClick={onGetEmailOtp}
													disabled={emailOtpMessageLoading || !isEmailValid}
												>
													{emailOtpMessageLoading ? <Preloader /> : "Get Code"}
												</button>
											)}
										</div>
									</div>
								</div>

								{/* handle email otp Verification */}
								{emailOtpMessageSuccess && (
									<div className="flex flex-col items-center sm:flex-row gap-2 sm:gap-4 md:gap-5 text-xs md:text-[13px]">
										<p className="w-full text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
											Enter Code :
										</p>
										<div className="space-y-1.5 w-full sm:w-[65%] md:w-3/5 xl:w-4/6">
											<div className="relative h-[45px] w-full zabalMedFont relative">
												<input
													type="tel"
													className="text-sm h-full w-full px-2.5 rounded border border-[#B8B8B8] text-[#393F42] bg-transparent outline-none placeholder:text-[#B8B8B8] zabalRegFont focus:border-2 focus:border-fortcore-green"
													placeholder="email otp"
													name="email_code"
													maxLength={6}
													value={email_code}
													onChange={handleChange}
												/>
												{verifyEmailOtpLoading && (
													<div className="absolute right-2.5 top-0 h-full w-[55px] grid place-items-center">
														<Preloader />
													</div>
												)}
											</div>
											<div className="pl-4 pr-2 text-[11px] flex justify-between text-fortcore-green zabalMedFont">
												{isShowEmailTimer && <CountDown timer={115} />}
												<div className="space-x-1.5 justify-self-end ">
													<span className="text-[#393F42]">
														Didn&apos;t get code?
													</span>
													<button
														className={`font-semibold ${
															isShowEmailTimer || emailOtpMessageLoading
																? "text-[#717E83]"
																: "text-fortcore-green"
														}`}
														onClick={onGetEmailOtp}
														disabled={
															isShowEmailTimer || emailOtpMessageLoading
														}
													>
														{emailOtpMessageLoading
															? "Sending..."
															: "Resend Code"}
													</button>
												</div>
											</div>
										</div>
									</div>
								)}

								{/* handle work status selection */}
								<div className="flex flex-col items-center sm:flex-row gap-2 sm:gap-4 md:gap-5 relative z-[1]">
									<p className="w-full text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
										Work Status :
									</p>
									<div className="w-full sm:w-[65%] md:w-3/5 xl:w-4/6 relative">
										<PlainSelect
											context="select work status"
											isOpened={toggleWorkStatus}
											currentText={work_status}
											handleToggle={handleToggleWorkStatus}
										/>
										{toggleWorkStatus && (
											<div className="absolute z-[2] w-full top-48px">
												<SelectDropDown
													arrOptions={[
														"Employed",
														"Self employed",
														"Unemployed",
													]}
													onHandleSelect={(d) => {
														setPersonalForm((prev) => ({
															...prev,
															work_status: d,
														}));
														setTimeout(() => {
															setToggleWorkStatus(false);
														}, 100);
													}}
												/>
											</div>
										)}
									</div>
								</div>

								{/* handle employer input */}
								<div className="flex flex-col items-center sm:flex-row gap-2 sm:gap-4 md:gap-5 text-xs md:text-[13px]">
									<p className="w-full text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
										Employer :
									</p>
									<div className="h-[45px] w-full sm:w-[65%] md:w-3/5 xl:w-4/6 zabalMedFont">
										<input
											type="text"
											className="text-sm h-full w-full px-2.5 rounded border border-[#B8B8B8] text-[#393F42] bg-transparent outline-none placeholder:text-[#B8B8B8] zabalRegFont focus:border-2 focus:border-fortcore-green"
											placeholder="employer"
											name="employer_name"
											value={employer_name}
											onChange={handleChange}
										/>
									</div>
								</div>

								{/* handle salary range selection */}
								<div className="flex flex-col items-center sm:flex-row gap-2 sm:gap-4 md:gap-5 text-xs md:text-[13px] relative z-1">
									<p className="w-full text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
										Salary Range :
									</p>
									<div className="w-full sm:w-[65%] md:w-3/5 xl:w-4/6 relative">
										<PlainSelect
											context="choose salary range"
											isOpened={toggleSalaryRange}
											currentText={salary_range}
											handleToggle={handleToggleSalaryRange}
										/>
										{toggleSalaryRange && (
											<div className="absolute w-full top-48px z-[2]">
												<SelectDropDown
													arrOptions={[
														"Below N50,000",
														"N50,000 - N100,000",
														"N100,000 - N500,000",
														"Above N1,000,000",
													]}
													onHandleSelect={(d) => {
														setPersonalForm((prev) => ({
															...prev,
															salary_range: d,
														}));
														setTimeout(() => {
															setToggleSalaryRange(false);
														}, 100);
													}}
												/>
											</div>
										)}
									</div>
								</div>

								{/* handle number of dependents selection */}
								<div className="flex flex-col items-center sm:flex-row gap-2 sm:gap-4 md:gap-5 text-xs md:text-[13px]">
									<p className="w-full text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
										Number Of Dependent :
									</p>
									<div className="w-full sm:w-[65%] md:w-3/5 xl:w-4/6 relative">
										<PlainSelect
											context="select number of dependent"
											isOpened={toggleNumberOfDependent}
											currentText={number_of_dependent}
											handleToggle={() =>
												setToggleNumberOfDependent((prev) => !prev)
											}
										/>
										{toggleNumberOfDependent && (
											<div className="absolute z-[2] w-full top-48px">
												<SelectDropDown
													arrOptions={["None", "1", "2", "3", "4", "Above 4"]}
													onHandleSelect={(d) => {
														setPersonalForm((prev) => ({
															...prev,
															number_of_dependent: d,
														}));
														setTimeout(() => {
															setToggleNumberOfDependent(false);
														}, 100);
													}}
												/>
											</div>
										)}
									</div>
								</div>

								{/* handle home address input */}
								<div className="flex flex-col items-center sm:flex-row gap-2 sm:gap-4 md:gap-5 text-xs md:text-[13px]">
									<p className="w-full text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
										Home Address:
									</p>
									<div className="h-[45px] w-full sm:w-[65%] md:w-3/5 xl:w-4/6 zabalRegFont">
										<input
											type="text"
											className="h-full tracking-wide w-full px-2.5 rounded border border-[#B8B8B8] text-[#393F42] bg-transparent outline-none text-[13px] lg:text-sm placeholder:text-[#B8B8B8] focus:border-2 focus:border-fortcore-green"
											placeholder="home address"
											name="home_address"
											value={home_address}
											onChange={handleChange}
										/>
									</div>
								</div>

								{/* handle number of iD selection */}
								<div className="flex flex-col items-center sm:flex-row gap-2 sm:gap-4 md:gap-5 text-xs md:text-[13px]">
									<p className="w-full text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
										Means of Identification :
									</p>
									<div className="w-full sm:w-[65%] md:w-3/5 xl:w-4/6 relative">
										<PlainSelect
											context="choose Id type"
											isOpened={toggleIdType}
											currentText={id_type}
											handleToggle={() => setToggleIdType((prev) => !prev)}
										/>
										{toggleIdType && (
											<div className="absolute z-[2] w-full top-48px">
												<SelectDropDown
													arrOptions={[
														"International Passport",
														"Driver's Licence",
														"National Identity Number (NIN)",
														"Voter's Card",
													]}
													onHandleSelect={(d) => {
														setPersonalForm((prev) => ({
															...prev,
															id_type: d,
														}));
														setTimeout(() => {
															setToggleIdType(false);
														}, 100);
													}}
												/>
											</div>
										)}
									</div>
								</div>

								{/* handle id number input */}
								<div className="flex flex-col items-center sm:flex-row gap-2 sm:gap-4 md:gap-5 text-xs md:text-[13px]">
									<p className="w-full text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
										ID No:
									</p>
									<div className="h-[45px] w-full sm:w-[65%] md:w-3/5 xl:w-4/6 zabalRegFont">
										<input
											type="text"
											className="h-full tracking-wide w-full px-2.5 rounded border border-[#B8B8B8] text-[#393F42] bg-transparent outline-none text-[13px] lg:text-sm placeholder:text-[#B8B8B8] focus:border-2 focus:border-fortcore-green"
											placeholder="ID Number"
											name="id_number"
											value={id_number}
											onChange={handleChange}
										/>
									</div>
								</div>

								{/* handle id expiry date input */}
								{id_type !== "" &&
									id_type !== "National Identity Number (NIN)" && (
										<div className="flex flex-col items-center sm:flex-row gap-2 sm:gap-4 md:gap-5 text-xs md:text-[13px]">
											<p className="w-full text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
												ID Expiry Date:
											</p>
											<div
												className={`h-[45px] relative w-full sm:w-[65%] md:w-3/5 xl:w-4/6 ${
													expiry_date === "" ? "mb-2.5" : "mb-0"
												}`}
											>
												<input
													type="date"
													className={`h-full tracking-wide w-full px-2.5 rounded border border-[#B8B8B8] text-[#393F42] zabalRegFont bg-transparent outline-none text-[13px] lg:text-sm placeholder:text-[#B8B8B8] focus:border-2 focus:border-fortcore-green ${
														expiry_date === ""
															? "text-[#B8B8B8]"
															: "text-[#393F42]"
													}`}
													min={moment().format("YYYY-MM-DD")}
													name="expiry_date"
													value={expiry_date}
													onChange={handleChange}
												/>
												{expiry_date === "" && (
													<p className="pt-0.5 text-xs zabalMedFont text-red-500">
														ID Card expiry date must be specified
													</p>
												)}
											</div>
										</div>
									)}

								{/* handle bank account listing */}
								<div className="flex flex-col sm:flex-row sm:items-center justify-between sm:justify-normal gap-2 sm:gap-4 md:gap-5 text-xs md:text-[13px]">
									<p className="text-[#393F42] text-xs md:text-[13px] zabalMedFont sm:w-[35%] md:w-2/5 xl:w-2/6">
										Link Bank Account :
									</p>
									<div className="sm:w-[65%] md:w-3/5 zabalMedFont lg:text-sm flex gap-3 justify-between text-fortcore-green items-start">
										{bank_account && (
											<div className="space-y-1">
												<p>{bank_account?.bankName}</p>
												<p className="text-xs text-[#8b8b8b]">
													{bank_account?.accountNo}
												</p>
											</div>
										)}
										<button
											type="button"
											onClick={() => dispatch(openAddBankAccountModal())}
											className={`${
												bank_account
													? "text-primary-color"
													: "text-fortcore-green"
											}`}
										>
											{bank_account ? "Change " : "Add "}Account
										</button>
									</div>
								</div>
							</div>
							<div className="bg-[#E3E9EC] h-[1px] w-full hidden sm:block"></div>

							{/* form buttons */}
							<div className="hidden sm:flex justify-end gap-4">
								{location.pathname === "/leasing/new-transaction" &&
									isProceedBtnValid() && (
										<CustomWhiteBtn
											text="maybe later"
											width="120px"
											height="42px"
											fontSize="13px"
											onRequestClick={onProceedToMarketPlace}
										/>
									)}
								<CustomGreenBtn
									text="proceed"
									width="120px"
									height="42px"
									fontSize="13px"
									isDisabled={isProceedBtnValid() || updatingUserAccountLoading}
									onRequestClick={onProceedBtnClick}
									isLoading={updatingUserAccountLoading}
								/>
							</div>
							<div className="flex flex-col gap-4 pt-4 sm:hidden">
								<CustomGreenBtn
									text="proceed"
									isDisabled={isProceedBtnValid() || updatingUserAccountLoading}
									onRequestClick={onProceedBtnClick}
									isLoading={updatingUserAccountLoading}
								/>
								{location.pathname === "/leasing/new-transaction" &&
									isProceedBtnValid() && (
										<CustomWhiteBtn
											text="maybe later"
											onRequestClick={onProceedToMarketPlace}
										/>
									)}
							</div>
						</div>
					</div>
				</div>
			</Container>
		</>
	);
};
export default PersonalForm;

PersonalForm.propTypes = {
	onCloseForm: PropTypes.func,
};
